module.exports = __webpack_public_path__ + "assets/img/18_1812_big.e0ff8009.jpg";